import { TicketDto } from "../../web-api-client";
import { Badge } from "../ui/badge";
import { Card, CardContent } from "../ui/card";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { AppointmentCard } from "./AppointmentCard";
import MobileHeader from "../MobileHeader";
import { useEffect } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

interface Props {
  data: TicketDto[];
  onBack: () => void;
  onViewDetail: (ticket: TicketDto) => void;
  isMobile?: boolean;
}

export const SearchTicketResult = ({
  data,
  onBack,
  onViewDetail,
  isMobile,
}: Props) => {
  const { t } = useLanguage();
  const getStatusBadge = (status: string) => {
    switch (status) {
      case "Đã đặt hẹn":
        return (
          <Badge className="bg-medical-success text-white">
            {t("dadathen")}
          </Badge>
        );
      case "pending":
        return (
          <Badge className="bg-medical-warning text-white">{t("chokham")}</Badge>
        );
      case "cancelled":
        return <Badge variant="destructive">{t("dahuy")}</Badge>;
      default:
        return <Badge variant="outline">{status}</Badge>;
    }
  };

  return (
    <motion.div
      key="result"
      initial={{ y: "100%", opacity: 0, scale: 0.95 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      exit={{ y: "-100%", opacity: 0, scale: 0.95 }}
      transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1], // smooth expo-out
      }}
      className="bg-gray-100 h-screen"
    >
      <Card
        style={{ border: "none", boxShadow: "none", background: "transparent" }}
      >
        {!isMobile && (
          <div className="flex items-center max-w-4xl mx-auto mt-4 px-4">
            <button className="flex items-center z-50 text-gray-600 hover:text-gray-800 transition-colors">
              <ArrowLeft className="w-5 h-5 mr-2" />
              <span className="font-medium" onClick={onBack}>
                {t("quayve")}
              </span>
            </button>
          </div>
        )}

        <CardContent className="pt-4 h-screen" style={{ padding: "1rem" }}>
          <div className="space-y-4 flex flex-col justify-center max-w-4xl mx-auto items-center">
            {data.map((record, idx) => (
              <AppointmentCard
                key={idx}
                record={record}
                isMobile={isMobile}
                getStatusBadge={getStatusBadge}
                onViewDetail={onViewDetail}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};
